import CustomButton from "@/components/button"
import { Image, Badge, Popover } from "antd"
import React, { FC, useState, useEffect, useCallback } from "react"

const NotificationIcon = "/icons/notification.svg";
import { useAuthStore } from "@/store/auth"
import { getUnreadNotificationCount } from "@/shared/api"
import { ensureBrowserPush } from "@/services/pushNotifications"
import NotificationPanel from "../notifications-panel/NotificationPanel"
import "./index.less"

const getUserId = (user: { _id?: string; id?: string } | null | undefined): string | null => {
  return user?._id || user?.id || localStorage.getItem('userId');
};

const NotificationsButton: FC = () => {
  const [visible, setVisible] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const user = useAuthStore(state => state.user);
  const userId = getUserId(user);

  const fetchUnreadCount = useCallback(async () => {
    if (!userId) {
      setUnreadCount(0);
      return;
    }
    
    try {
      const count = await getUnreadNotificationCount(userId);
      setUnreadCount(count);
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  }, [userId]);

  useEffect(() => {
    fetchUnreadCount();
    
    const interval = setInterval(fetchUnreadCount, 30000);
    
    return () => clearInterval(interval);
  }, [fetchUnreadCount]);

  useEffect(() => {
    if (!userId) return;
    ensureBrowserPush(userId).catch((error) => {
      console.error('Failed to enable browser push:', error);
    });
  }, [userId]);

  const handleVisibleChange = (newVisible: boolean) => {
    setVisible(newVisible);
    if (!newVisible) {
      setTimeout(fetchUnreadCount, 500);
    }
  };

  return (
    <Popover
      content={<NotificationPanel onClose={() => setVisible(false)} />}
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      placement="bottomRight"
      overlayClassName="notification-popover"
      arrow={false}
    >
      <Badge count={unreadCount} offset={[-5, 5]} size="small">
        <CustomButton 
          className={"notifications-button"} 
          icon={<Image src={NotificationIcon} preview={false} />} 
        />
      </Badge>
    </Popover>
  )
}

export default NotificationsButton
